import { Header } from '../components/Header';

const videos = [
  {
    title: 'Aula 01 - Visão geral da plataforma',
    description: 'Conheça o painel principal, os recursos e o fluxo inicial.',
    fileName: 'aula_01.mp4'
  },
  {
    title: 'Aula 2.01 - Criar contato (modo manual)',
    description: 'Cadastro completo de contatos e boas práticas de organização.',
    fileName: 'Aula_2_01_Criar_Contato_modo_manual.mp4'
  },
  {
    title: 'Aula 2.02 - Importando contatos via planilha',
    description: 'Importe listas em lote e valide sua planilha antes do envio.',
    fileName: 'Aula_2_02_Importando_Contatos_via_Planilha.mp4'
  },
  {
    title: 'Aula 04 - Ações de envio',
    description: 'Crie campanhas, ajuste mensagens e acompanhe os disparos.',
    fileName: 'AULA_04_ACOES_DE_ENVIO.mp4'
  },
  {
    title: 'Aula 05 - Processo completo',
    description: 'Veja o fluxo completo do cadastro à execução das ações.',
    fileName: 'AULA_05_PROCESSO_COMPLETO.mp4'
  },
  {
    title: 'Aula 06 - Modelos de textos para envio',
    description: 'Aprenda a salvar, padronizar e reaproveitar textos nas ações de envio.',
    fileName: 'AULA_06_MODELOS_DE_TEXTOS_PARA_ENVIO.mp4'
  },
  {
    title: 'Aula 07 - Anexar identidade do oficial',
    description: 'Veja como anexar a identificação funcional para reforçar a validação do contato.',
    fileName: 'AULA_07__Anexar_Identidade_do_Oficial.mp4'
  },
  {
    title: 'Aula 08 - Certificação de mandados',
    description: 'Entenda o fluxo de certificação e o registro correto dos mandados na plataforma.',
    fileName: 'Aula_8_CERTIFICACAO_DE_MANDADOS.mp4'
  },
  {
    title: 'Aula 08.1 - Ação de envio com mensagem e documento salvos',
    description: 'Combine mensagem salva e documento salvo para agilizar campanhas recorrentes.',
    fileName: 'AULA_08_1_Acao_Envio_com_Uso_deMensagem_Salva_e_Documento_salvo.mp4'
  },
  {
    title: 'Aula 09 - Uso de IA para gerar certidões',
    description: 'Confira como usar os recursos de IA para acelerar a geração de certidões.',
    fileName: 'AULA_09_Uso_de_IA_para_gerar_certidoes.mp4'
  }
];

const buildVideoUrl = (fileName: string) => {
  const baseUrl = import.meta.env.VITE_LEARNING_VIDEOS_BASE_URL as string | undefined;
  if (baseUrl) {
    const normalizedBase = baseUrl.replace(/\/$/, '');
    return `${normalizedBase}/${encodeURIComponent(fileName)}`;
  }
  return encodeURI(`/assets/videos/${fileName}`);
};

export function LearningPage() {
  return (
    <>
      <Header
        title="Aprendizado"
        subtitle="Treinamentos rápidos para usar a plataforma com mais segurança."
      />
      <div className="p-6">
        <div className="mb-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <p className="text-sm text-slate-600">
            Todos os vídeos ficam disponíveis aqui para consulta. Assista na ordem sugerida para
            aproveitar melhor o conteúdo.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
          {videos.map((video) => {
            const src = buildVideoUrl(video.fileName);
            return (
              <div
                key={video.fileName}
                className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
              >
                <div className="aspect-video bg-slate-900">
                  <video
                    className="h-full w-full object-cover"
                    controls
                    preload="metadata"
                    src={src}
                  />
                </div>
                <div className="space-y-2 p-4">
                  <h3 className="text-base font-semibold text-gray-900">{video.title}</h3>
                  <p className="text-sm text-gray-600">{video.description}</p>
                  <a
                    href={src}
                    className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-slate-900"
                  >
                    Assistir em nova aba
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 3h7v7m0-7L10 14m-4 0h4v4H6v-4z" />
                    </svg>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
